import React from "react";
import "./MCADIntegration.css";
import MCADIntegrationOverview from "./MCADIntegrationOverview";
import NX from "../../../assets/images/plmimplementationimage/MCADIntegrationimage/NX-Logo.png";
import catia from "../../../assets/images/plmimplementationimage/MCADIntegrationimage/CATIA-Logo.png";
import creo from "../../../assets/images/plmimplementationimage/MCADIntegrationimage/creo-logo.png";
import solidworks from "../../../assets/images/plmimplementationimage/MCADIntegrationimage/solidwork-logo.png";
import solidedge from "../../../assets/images/plmimplementationimage/MCADIntegrationimage/solidedge-logo.png";
import autocad from "../../../assets/images/plmimplementationimage/MCADIntegrationimage/autocad-logo.png";
import BannerImage from "../../../assets/other_image/intigretion.jpg";
import { NavLink } from "react-router-dom";
import Letsgetintouch from "../BusinessProcessAndChangeManagement/Letsgetintouch";
import Banner from "../Banner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";
import { Helmet } from "react-helmet-async";

const MCADIntegration = () => {
  const integrations = [
    {
      src: NX,
      label: "Teamcenter Integration for NX",
      to: "/teamcenter/mcad-integration/nx-integration",
    },
    {
      src: catia,
      label: "Teamcenter Integration for Catia V5",
      to: "/teamcenter/mcad-integration/catia-integration",
    },
    {
      src: creo,
      label: "Teamcenter Integration for Creo Pro/ENGINEER",
      to: "/teamcenter/mcad-integration/pro-engineer-integration",
    },
    {
      src: solidworks,
      label: "Teamcenter Integration for SolidWorks",
      to: "/teamcenter/mcad-integration/solidwork-integration",
    },
    {
      src: solidedge,
      label: "Teamcenter Integration for Solid Edge",
      to: "/teamcenter/solidedge-integration",
    },
    {
      src: autocad,
      label: "Teamcenter Integration for AutoCAD",
      to: "/teamcenter/mcad-integration/autocad-integration",
    },
  ];
  return (
    <>
     <Helmet>
  <title>MCAD Integration Services in Pune & India | NexTech PLM</title>
  <meta
    name="description"
    content="Optimize your product development with expert MCAD integration in Pune and across India. Streamline CAD data and enhance collaboration with NexTech PLM. Get in touch today for a free consultation!"
  />
  <meta
    name="robots"
    content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
  />
</Helmet>

    <section className="MCADIntegration-management">
      <Banner
        image={BannerImage} // Pass the image for this page
        heading="MCAD Integration with Teamcenter" // Pass the heading text for this page
      />
      <div>
         <FloatingContactUs />
      </div>
      

      <MCADIntegrationOverview />
      <section style={{ background: "#f5f7fa" }}>
        <div className="benefits container">
          <h4 className="MCADIntegration-page-heading">Unlock the Power :</h4>
          <h5 className="MCADIntegration-subheading">
            Discover the Transformative Benefits of MCAD Integration with NexTech !
          </h5>
          <ul className="custom-bullets">
            <li>
              Single source of product information in support of your complete
              design through the manufacturing process{" "}
            </li>
            <li>
              Shorter time to market with faster product change and approval
              processes{" "}
            </li>
            <li>
              Higher levels of understanding and communication among product
              teams throughout the supply chain
            </li>
            <li>Reduced development cycle and cost </li>
          </ul>
        </div>
      </section>
      <section>
  <div className="solutions container">
    <div className="solutions-content">
      <div className="row">
        <div className="col-md-6 col-12">
          <h4 className="MCADIntegration-page-heading"> Solutions</h4>

          <ul className="custom-bullets">
         <li>Integration with NX </li>
            <li>Integration with Catia</li>
            <li>Integration with Creo</li>
            <li>Integration with SolidWorks</li>
            <li>Integration with Solid Edge </li>
            <li>Integration with AutoCAD Vertical </li>
          </ul>
 
        </div>

        <div className="col-md-6 col-12">
          <div className="quick-links">
            <h4>Quick Links</h4>
            <ul>
            <li><NavLink to={"/teamcenter/ecad-integration"} >ECAD Integration</NavLink></li>
            <li><NavLink to={"/teamcenter/implementation"} >Teamcenter Implementation</NavLink></li>
             
             <li><NavLink to={"/teamcenter/cae-integration"} >Teamcenter Integration for CAE
             </NavLink></li>
             <li><NavLink to={"/teamcenter/cam-integration"} >Teamcenter Integration for CAM
             </NavLink></li>
             <li><NavLink to={"/teamcenter/upgrade-migration"} >Teamcenter Upgrade & Migration
             </NavLink></li>
             <li><NavLink to={"/teamcenter/aw-client"} >Implementation of Teamcenter AW Client
             </NavLink></li>
             <li><NavLink to={"/teamcenter/cloud-implementation"} >Teamcenter Implementation on Cloud</NavLink></li>
             <li><NavLink to={"/teamcenter/cybersecurity"} >Teamcenter Cyber security</NavLink></li>
             
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
          <section className="container">
          <h5 className="Mcad-integration-h5">Integration :</h5>
          <p className="plmimplementationparagraph">
            2TIER & 4TIER integration, synchronize title block using Teamcenter
            database attributes, AutoCAD and Vertical Mechanical Properties
            Synchronization, Seed Parts, Configuration of NX to JT Translation,
            NX Manager, SQL Optimization, Additional Columns, Complex Attribute
            Mapping like project, workflow attributes, occurrence note type,
            EPM-tessellation-handler, Legacy data import using UG Import, UG
            Clone, IPS Data Upload, starting NX in standby mode, enabling icon
            display in for various objects and so on 
          </p>
          <div className="container mt-4">
            <div className="row">
              {integrations.map((item, index) => (
                <div
                  className="col-sm-6 col-md-4 col-lg-4 mb-4 text-center"
                  key={index}
                >
                  <NavLink to={item.to} className="mcad-link">
                    <img
                      src={item.src}
                      alt={item.label}
                      className="img-fluid"
                      style={{ maxHeight: "150px" }}
                    />
                    <p>{item.label}</p>
                  </NavLink>
                </div>
              ))}
            </div>
          </div>
          </section>
      <section style={{ background: "#f5f7fa" }}>
        <div className="best-practice container">
          <h4 className="MCADIntegration-page-heading">Best Practices</h4>
          <p className="plmimplementationparagraph">
            At NexTech PLM Solutions, we empower our customers by enabling
            industry-leading best practices for managing complex CAD, CAM, and
            CAE data in highly controlled environments. Whether you're creating,
            configuring, or editing intricate design data, we streamline
            processes to ensure efficient data management. Our expertise covers
            a wide range of essential tasks, such as managing relationships and
            associated auxiliary files, converting files to JT format, and
            storing mechanical properties for easy access.
          </p>
          <p className="plmimplementationparagraph">
            We support multi-session workflows, ensuring seamless CAD-centric
            data transfers across multiple sites. Our solutions also include
            managing family tables, precise configurations, baseline control,
            effectivity tracking, and variant and option management.
            Additionally, we optimize partial data loading to improve
            performance and productivity, helping organizations stay agile while
            working with large datasets. From collaborative engineering to
            lifecycle management, our solutions are designed to improve
            efficiency, reduce errors, and drive innovation in your PLM (Product
            Lifecycle Management) environment.
          </p>
        </div>
      </section>
      <section>
        <div className="why-nextech container">
          <h4 className="MCADIntegration-page-heading">Why NexTech?</h4>
          <h5 className="MCADIntegration-subheading">For MCAD Integration</h5>
          <ul className="custom-bullets">
            <li>
              Seamless integration with leading MCAD software such as NX, Catia,
              Creo, SolidWorks, Solid Edge, AutoCAD, and Inventor for
              comprehensive CAD data management.
            </li>
            <li>
              Expertise in enabling best practices for managing CAD/CAM/CAE data
              in managed mode environments, ensuring efficient creation,
              configuration, and editing.
            </li>
            <li>
              Specialized methodologies to optimize CAD data performance,
              including synchronization of mechanical properties, precise JT
              conversion, and configuration of NX to JT translation.
            </li>
            <li>
              Proficiency in data migration and legacy data import using
              advanced tools like UG Import, UG Clone, and IPS Data Upload,
              ensuring smooth transition and continuity of workflows.
            </li>
            <li>
              Robust capabilities in implementing complex attribute mapping and
              relationship management, facilitating effective communication and
              collaboration among product teams across the supply chain.
            </li>
          </ul>
        </div>
      </section>
      <Letsgetintouch />
    </section>
</>
  );
};

export default MCADIntegration;
